import React, { memo } from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import moment from 'moment'
import { IUseCreateShipmentFormProps, useCreateShipmentForm } from '../hooks/useCreateShipmentForm'
import { TCreateShipmentSchema } from '../schema'
import { IUseCreateShipmentFormContext } from '../types'

const TODAY = moment().toISOString()

export interface ICreateShipmentFormProviderProps
  extends Omit<IUseCreateShipmentFormProps, 'context'> {
  children: React.ReactNode
}

const CreateShipmentFormProvider = memo<ICreateShipmentFormProviderProps>(
  ({ children, defaultValues = {}, ...props }) => {
    const context: IUseCreateShipmentFormContext = {
      dateNow: TODAY,
    }

    const methods = useCreateShipmentForm({
      context,
      defaultValues,
      ...props,
    })

    return <FormProvider {...methods}>{children}</FormProvider>
  }
)

export default CreateShipmentFormProvider

export const useCreateShipmentFormContext = () => useFormContext<TCreateShipmentSchema>()
